/* Bumpers "notify me when it's back in stock": box under the size picker + dialog. Vanilla JS. */
(function () {
  'use strict';
  if (window.__bumpersWaitlist) return;
  window.__bumpersWaitlist = true;

  var KEY_DONE = 'bumpers_waitlist_done'; // variant ids this browser already asked about
  var KEY_VID = 'bumpers_popup_vid';      // same anonymous id the club popup uses

  function ls(k, v) {
    try {
      if (v === undefined) return window.localStorage.getItem(k);
      window.localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function doneList() { try { return JSON.parse(ls(KEY_DONE) || '[]'); } catch (e) { return []; } }
  function markDone(id) { var l = doneList(); if (l.indexOf(String(id)) < 0) l.push(String(id)); ls(KEY_DONE, JSON.stringify(l.slice(-50))); }
  function visitorId() {
    var v = ls(KEY_VID);
    if (!v) { v = Date.now().toString(36) + Math.random().toString(36).slice(2, 12); ls(KEY_VID, v); }
    return v;
  }
  function fill(s, o) { return String(s || '').replace(/\[(\w+)\]/g, function (m, k) { return o[k] == null ? '' : o[k]; }); }

  // Israeli mobile / landline → +972…, else null (same rule as the club popup)
  function normalizePhone(raw) {
    var d = String(raw || '').replace(/\D/g, '');
    if (d.indexOf('972') === 0) d = d.slice(3);
    d = d.replace(/^0+/, '');
    if (d.length === 9 && d.charAt(0) === '5') return '+972' + d;
    if (d.length === 8 && /^[2-489]/.test(d)) return '+972' + d;
    return null;
  }

  function track(name, params) {
    try { window.dataLayer && window.dataLayer.push(Object.assign({ event: name }, params || {})); } catch (e) {}
    try { typeof window.gtag === 'function' && window.gtag('event', name, params || {}); } catch (e) {}
  }

  function init() {
    var box = document.getElementById('bwl');
    var ov = document.getElementById('bwl-ov');
    var cfgEl = document.getElementById('bwl-config');
    if (!box || !ov || !cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var t = cfg.t || {};
    // move the dialog to the end of <body> so floating widgets (cart, accessibility, club tab) stay underneath
    document.body.appendChild(ov);
    var dlg = ov.querySelector('.bwl-box');
    var form = ov.querySelector('form');
    var openBtn = box.querySelector('[data-bwl-open]');
    var msg = box.querySelector('[data-bwl-msg]');
    var current = null; // { id, size } — the sold-out size the box / dialog is about
    var picked = null;  // size chosen inside the dialog when it was opened from the invite line
    var chips = ov.querySelector('[data-bwl-chips]');
    var pickWrap = ov.querySelector('[data-bwl-pick]');

    // sold-out sizes of this colour that really exist as variants
    function oosList() {
      var out = [], rs = document.querySelectorAll('input[name="v46-size"]');
      for (var i = 0; i < rs.length; i++) { var x = fromRadio(rs[i]); if (x) out.push(x); }
      return out;
    }
    // the box lives right under the size grid, where shoppers look for their size
    var hint = document.querySelector('#v46-size-container');
    if (hint) { var after = hint.nextElementSibling && hint.nextElementSibling.classList.contains('v46-hint') ? hint.nextElementSibling : hint; after.parentNode.insertBefore(box, after.nextSibling); }
    // little bell on every sold-out size that can be requested
    var rs0 = document.querySelectorAll('input[name="v46-size"]');
    for (var j = 0; j < rs0.length; j++) if (fromRadio(rs0[j]) && rs0[j].nextElementSibling) rs0[j].nextElementSibling.classList.add('bwl-bell');
    var lastFocus = null;
    var busy = false;

    // static texts
    ov.querySelector('.bwl-h').textContent = t.title;
    ov.querySelector('[data-bwl-consent-text]').textContent = t.consent;
    var fine = ov.querySelector('[data-bwl-fine]');
    fine.textContent = t.fine || '';
    fine.hidden = !t.fine;
    ov.querySelector('.bwl-form .bwl-submit').textContent = t.submit;
    ov.querySelector('[data-bwl-ok-title]').textContent = t.ok_title;
    ov.querySelector('.bwl-x').setAttribute('aria-label', t.close);
    var labels = ov.querySelectorAll('[data-bwl-l]');
    for (var i = 0; i < labels.length; i++) labels[i].textContent = t[labels[i].getAttribute('data-bwl-l')] || '';

    function vars() { return { size: current ? current.size : '', product: cfg.title }; }

    function show(sel) {
      current = sel;
      box.classList.remove('is-invite');
      if (!sel) {
        // no sold-out size picked: keep a quiet invite while this colour has any sold-out size
        if (!oosList().length) { box.hidden = true; return; }
        box.classList.add('is-invite');
        box.classList.remove('is-done');
        msg.textContent = t.invite;
        openBtn.hidden = false;
        openBtn.textContent = t.invite_btn;
        box.hidden = false;
        return;
      }
      var done = doneList().indexOf(String(sel.id)) >= 0;
      var single = !sel.size;
      // how many other colours have this size (set by the engine's draw() on #v46-swatches)
      var sw = document.getElementById('v46-swatches');
      var others = sw && sw.dataset.size === sel.size ? parseInt(sw.dataset.others, 10) : NaN;
      var boxText = single ? t.box_single
        : others === 0 ? t.box_none
        : others === 1 ? (t.box_more1 || t.box)
        : others > 1 ? (t.box_more || t.box) : t.box;
      var v = vars(); v.n = others;
      msg.textContent = fill(done ? (single ? t.done_box_single : t.done_box) : boxText, v);
      box.classList.toggle('is-done', done);
      openBtn.hidden = done;
      openBtn.textContent = t.btn;
      box.hidden = false;
    }

    // the size engine marks sold-out sizes with data-av="false"; "missing-N" values = size not made in this colour
    function fromRadio(r) {
      if (!r || r.getAttribute('data-av') !== 'false' || !/^\d+$/.test(r.value)) return null;
      return { id: r.value, size: r.getAttribute('data-label') || '' };
    }

    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'v46-size') show(fromRadio(e.target));
    });
    // initial state (arriving with ?size=…, or a sold-out single-variant product)
    // the engine may tick the ?size= radio after we start (no change event), so look again once the page settles
    function sync() {
      var checked = document.querySelector('input[name="v46-size"]:checked');
      if (checked) show(fromRadio(checked));
      else if (cfg.single) show({ id: String(cfg.single.id), size: '' });
      else show(null);
    }
    sync();
    setTimeout(sync, 400);
    window.addEventListener('load', sync);

    function setErr(k, text) {
      var el = ov.querySelector('[data-bwl-err="' + k + '"]');
      if (el) { el.textContent = text || ''; el.hidden = !text; }
      var inp = form.elements[k];
      if (inp) inp.classList.toggle('is-invalid', !!text);
    }

    function renderChips() {
      var done = doneList();
      chips.innerHTML = '';
      var asked = [];
      oosList().forEach(function (x) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bwl-chip' + (picked && picked.id === x.id ? ' on' : '');
        b.textContent = x.size;
        if (done.indexOf(String(x.id)) >= 0) asked.push(x.size);
        b.addEventListener('click', function () { picked = x; setErr('size', ''); renderChips(); ov.querySelector('[data-bwl-lead]').textContent = fill(t.lead, { size: x.size, product: cfg.title }); });
        chips.appendChild(b);
      });
      // sizes this browser already asked about: said in words under the chips, not as a bare ✓
      var note = ov.querySelector('[data-bwl-asked]');
      if (note) { note.textContent = asked.length ? fill(t.asked, { sizes: asked.join(', ') }) : ''; note.hidden = !asked.length; }
    }

    function open() {
      lastFocus = document.activeElement;
      picked = null;
      var choose = !current;
      pickWrap.hidden = !choose;
      if (choose) renderChips();
      ov.querySelector('[data-bwl-lead]').textContent = choose ? cfg.title : fill(current.size ? t.lead : t.lead_single, vars());
      view('form');
      ['phone', 'email', 'form', 'size', 'consent'].forEach(function (k) { setErr(k, ''); });
      ov.hidden = false;
      document.documentElement.classList.add('bwl-lock');
      requestAnimationFrame(function () { ov.classList.add('is-open'); dlg.focus({ preventScroll: true }); });
      track('bumpers_waitlist_open', { variant_id: current ? current.id : '', from: choose ? 'invite' : 'size' });
    }
    function close() {
      ov.classList.remove('is-open');
      document.documentElement.classList.remove('bwl-lock');
      setTimeout(function () { ov.hidden = true; }, 180);
      if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
    function view(name) {
      var v = ov.querySelectorAll('[data-bwl-view]');
      for (var i = 0; i < v.length; i++) v[i].hidden = v[i].getAttribute('data-bwl-view') !== name;
    }

    openBtn.addEventListener('click', open);
    ov.addEventListener('click', function (e) { if (e.target === ov || e.target.closest('[data-bwl-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ov.hidden) close(); });
    form.addEventListener('input', function (e) { if (e.target.name) setErr(e.target.name, ''); setErr('form', ''); });

    // 1. sign up in Shopify (same customer form as the club popup, so consent-sync / Flows / GHL pick it up)
    function subscribe(v) {
      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', v.email);
      if (v.name) fd.append('contact[first_name]', v.name);
      // no popup-club5 / newsletter tag: no club welcome, no coupon
      var tags = String(cfg.tags || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      if (v.phone) tags.push('phone:' + v.phone);
      // what they wait for, same wording as the GHL tag → a Shopify Email segment per product + size
      var product = String(cfg.title || '').replace(/\s*\/\/\s*/g, ' ').replace(/[,\s]+/g, ' ').trim();
      tags.push(('ממתין: ' + product + (v.size ? ' ' + v.size : '')).slice(0, 100));
      fd.append('contact[tags]', tags.join(', '));
      fd.append('contact[accepts_marketing]', 'true');
      return fetch(cfg.contactUrl || '/contact', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (res) {
          if (/\/challenge/.test(res.url)) return 'challenge';
          return /customer_posted=true/.test(res.url) ? 'ok' : 'error';
        }, function () { return 'network'; });
    }
    // 2. legal record of the consent (worker adds IP + User-Agent)
    function recordSignup(v, result) {
      try {
        fetch(cfg.signupUrl, {
          method: 'POST', keepalive: true, credentials: 'omit', headers: { 'Content-Type': 'text/plain' },
          body: JSON.stringify({
            shop: cfg.shop, version: 'waitlist', form: 'waitlist', email: v.email, name: v.name, phone: v.phone || '',
            consent_text: t.consent, consent_checked: true, page_url: location.href.split('#')[0],
            shopify_result: result, visitor_id: visitorId()
          })
        }).catch(function () {});
      } catch (e) {}
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      ['phone', 'email', 'form', 'size', 'consent'].forEach(function (k) { setErr(k, ''); });
      var sel = current || picked;
      var v = {
        size: sel ? sel.size : '',
        name: form.elements.name.value.trim(),
        email: form.elements.email.value.trim(),
        phoneRaw: form.elements.phone.value.trim()
      };
      v.phone = v.phoneRaw ? normalizePhone(v.phoneRaw) : null;
      var bad = false;
      if (!sel) { setErr('size', t.pick_err); bad = true; }
      if (!v.email) { setErr('email', t.req); bad = true; }
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.email)) { setErr('email', t.bad_email); bad = true; }
      if (!v.phoneRaw) { setErr('phone', t.req); bad = true; }
      else if (!v.phone) { setErr('phone', t.bad_phone); bad = true; }
      if (!form.elements.consent.checked) { setErr('consent', t.err_consent); bad = true; }
      if (bad) return;
      if (cfg.designMode) { view('ok'); return; }

      busy = true;
      var btn = form.querySelector('.bwl-submit');
      btn.disabled = true;
      subscribe(v).then(function (result) {
        recordSignup(v, result);
        if (result !== 'ok') throw new Error(result);
        return fetch(cfg.url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            shop: cfg.shop, product_handle: cfg.handle, product_title: cfg.title,
            variant_id: sel.id, variant_title: sel.size, name: v.name, phone: v.phone || '', email: v.email,
            locale: cfg.locale, page_url: location.href.split('#')[0], visitor_id: visitorId()
          })
        }).then(function (r) {
          return r.json().catch(function () { return {}; });
        });
      }).then(function (j) {
        if (j && j.ok) {
          markDone(sel.id);
          ov.querySelector('[data-bwl-ok-text]').textContent = fill(sel.size ? t.ok_text : t.ok_text_single, { size: sel.size, product: cfg.title });
          view('ok');
          show(current);
          track('bumpers_waitlist_submit', { variant_id: sel.id });
          try { typeof window.fbq === 'function' && window.fbq('track', 'Lead', { content_name: 'back_in_stock' }); } catch (e) {}
        } else if (j && j.error === 'available') setErr('form', t.available);
        else if (j && j.error === 'phone') setErr('phone', t.bad_phone);
        else if (j && j.error === 'email') setErr('email', t.bad_email);
        else setErr('form', t.err);
      }).catch(function () { setErr('form', t.err); })
        .then(function () { busy = false; btn.disabled = false; });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); });
  else setTimeout(init, 0);
})();
